import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "common-layout"
};
const _hoisted_2 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_3 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_4 = {
  class: "dialog-footer"
};
const _hoisted_5 = {
  class: "custom-tree-node"
};
const _hoisted_6 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_7 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_aside = _resolveComponent("el-aside");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.refresh
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("刷新", -1)]))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_input, {
        modelValue: $data.inputOrderNo,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputOrderNo = $event),
        style: {
          "width": "20%",
          "position": "relative",
          "margin-left": "30px"
        },
        placeholder: "输入工单号查询",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
        modelValue: $data.search,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.search = $event),
        style: {
          "width": "30%",
          "position": "relative",
          "margin-left": "30px"
        },
        maxlength: "50",
        "show-word-limit": "",
        placeholder: "输入使用单位",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: $data.createDateSearch,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.createDateSearch = $event),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "value-format": "YYYY-MM-DD",
        style: {
          "width": "250px",
          "left": "auto",
          "margin-left": "30px"
        },
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        onClick: $options.searchByCreateDate
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("查询", -1)]))]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_el_main, null, {
      default: _withCtx(() => [_createVNode(_component_el_table, {
        data: $data.tableData,
        style: {
          "width": "100%",
          "height": "50vh"
        },
        border: "",
        "row-class-name": $options.tableRowClassName,
        onSelectionChange: $options.handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          "min-width": "30",
          "max-width": "60"
        }), _createVNode(_component_el_table_column, {
          label: "工单号",
          "min-width": "140",
          "max-width": "200",
          prop: "orderNo"
        }), _createVNode(_component_el_table_column, {
          label: "电梯号",
          "min-width": "60",
          "max-width": "120",
          prop: "liftId"
        }), _createVNode(_component_el_table_column, {
          label: "产品编号",
          "min-width": "88",
          "max-width": "120",
          prop: "liftNum"
        }), _createVNode(_component_el_table_column, {
          label: "使用单位",
          "min-width": "188",
          "max-width": "200",
          prop: "unit"
        }), _createVNode(_component_el_table_column, {
          label: "设备品种",
          prop: "liftType"
        }), _createVNode(_component_el_table_column, {
          label: "创建时间",
          "min-width": "140",
          "max-width": "200",
          prop: "createDate",
          sortable: ""
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.createDate, "yyyy-MM-dd hh:mm:ss")), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "检测员",
          prop: "userAlias"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          "min-width": "70",
          "max-width": "120",
          fixed: "right"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            size: "small",
            style: {
              "margin-left": "0px"
            },
            onClick: $event => $options.getOrder(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("领取 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "row-class-name", "onSelectionChange"])]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "width": "96px",
        "height": "24px",
        "position": "relative",
        "left": "90%",
        "font-weight": "bold"
      },
      type: "info",
      plain: "",
      onClick: _cache[3] || (_cache[3] = $event => $options.allocationInBatch())
    }, {
      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("批量领取工单 ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[4] || (_cache[4] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[5] || (_cache[5] = $event => $data.pageSize = $event),
        "page-sizes": [10, 20],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.allocationDialog,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.allocationDialog = $event),
    title: "领取工单",
    "lock-scroll": false,
    draggable: "",
    "before-close": $options.closeAllocation
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
      onClick: $options.closeAllocation
    }, {
      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[8] || (_cache[8] = $event => $options.update())
    }, {
      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.allocationForm,
      ref: "form",
      "status-icon": "",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.selectUserName,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.selectUserName = $event),
        clearable: "",
        multiple: "",
        placeholder: "请选择辅检人员",
        onClick: _cache[7] || (_cache[7] = $event => $options.userNameByLiftId())
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.options, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.userId,
            label: item.userAlias,
            value: index
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue", "before-close"]), _createVNode(_component_el_dialog, {
    modelValue: $data.allocationDialogInBatch,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.allocationDialogInBatch = $event),
    title: "批量领取工单,选择辅检人员",
    "lock-scroll": false,
    draggable: "",
    "before-close": $options.closeBatch
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: $options.closeBatch
    }, {
      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      type: "primary",
      onClick: _cache[13] || (_cache[13] = $event => $options.getOrderAll())
    }, {
      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.allocationInbatchForm,
      ref: "form",
      "status-icon": "",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "300px",
          style: {
            "margin-top": "20px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_text, null, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" 请点击选择区域 ", -1)]))]),
            _: 1
          }), _createVNode(_component_el_tree, {
            data: $data.treeData,
            props: _ctx.defaulareaIdtProps,
            "node-key": "",
            ref: "tree",
            "highlight-current": "",
            "default-expanded-keys": $data.treeData,
            "expand-on-click-node": false,
            onNodeClick: $options.handleNodeClickInbatch
          }, {
            default: _withCtx(({
              node
            }) => [_createElementVNode("span", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(node.data.areaName), 1), _cache[22] || (_cache[22] = _createElementVNode("span", {
              class: "custom-tree-node-areaName"
            }, null, -1))])]),
            _: 1
          }, 8, ["data", "props", "default-expanded-keys", "onNodeClick"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_main, {
          style: {
            "height": "50%",
            "margin-top": "40px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table, {
            data: $data.tableDataAdd,
            style: {
              "width": "100%"
            },
            border: "",
            onSelectionChange: _cache[10] || (_cache[10] = data => {
              $data.toggleRowArr = data;
            }),
            "row-class-name": $options.tableRowClassName1
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              type: "selection"
            }), _createVNode(_component_el_table_column, {
              label: "检测员",
              prop: "userAlias"
            })]),
            _: 1
          }, 8, ["data", "row-class-name"]), _createVNode(_component_el_footer, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
              currentPage: $data.currentPage1,
              "onUpdate:currentPage": _cache[11] || (_cache[11] = $event => $data.currentPage1 = $event),
              "page-size": $data.pageSize1,
              "onUpdate:pageSize": _cache[12] || (_cache[12] = $event => $data.pageSize1 = $event),
              "page-sizes": [10, 20],
              small: $data.small1,
              background: $data.background1,
              layout: "total, sizes, prev, pager, next, jumper",
              total: $data.total1,
              prev: $data.prev1,
              pager: $data.pager1,
              next: $data.next1,
              jumper: $data.jumper1,
              onSizeChange: $options.handleSizeChange1,
              onCurrentChange: $options.handleCurrentChange1
            }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, $data.show2]])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue", "before-close"])]);
}